import type { SelectOption } from "../SelectField"
import {
  TIMEZONE_OPTIONS as SHARED_TIMEZONE_OPTIONS,
  getTimezoneLabel,
} from "@mimber/shared"

export const TIMEZONE_OPTIONS: SelectOption[] = SHARED_TIMEZONE_OPTIONS

export { getTimezoneLabel }
